export const iconAliases = {
  activities: 'build',
  alarms: 'warning',
  assembly: 'workspaces',
  calendar: 'calendar_today',
  card_view: 'grid_view',
  chart: 'ssid_chart',
  chart_min_max: 'align_vertical_center',
  companies: 'contacts',
  connectivity: 'wifi',
  equipment_basics: 'description',
  equipment_data: 'equalizer',
  filter: 'filter_list',
  histogram: 'pie_chart',
  insights: 'scatter_plot',
  list_view: 'view_agenda',
  line_chart: 'show_chart',
  map_view: 'map',
  no_content: 'screen_search_desktop',
  orders: 'assignment_turned_in',
  parts: 'extension',
  power_settings: 'power_settings_new',
  recommendations: 'lightbulb',
  sam_account: 'account_box',
  shopping_lists: 'assignment',
  sites: 'pin_drop',
  sort: 'sort_by_alpha',
  success: 'check_circle',
  table_view: 'list',
  users: 'people',
} as const;
